import Axios from 'axios';

import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    EMAIL_CHANGE,
    PASSWORD_CHANGE,
    CLEAR_AUTH_ERROR,
    AUTH_TOKEN_CHANGE,
} from './constants';


export const setAuthToken = authToken => ({
    type: AUTH_TOKEN_CHANGE,
    authToken,
});

const optionAxios = {
    headers: {
        'Access-Control-Allow-Origin': '*',
    },
};

export const signInFunc = (email, password) => (dispatch) => {
    Axios.post(
        '/v1/authenticate', {
            email,
            password,
        },
        optionAxios,
    )
        .then((response) => {
            dispatch(setAuthToken(response.data.authToken));
            dispatch({ type: LOGIN_SUCCESS });
        }).catch((err) => {
            dispatch({ type: LOGIN_ERROR, err });
        });
};


export const setEmail = authEmail => ({
    type: EMAIL_CHANGE,
    authEmail,
});

export const setPassword = password => ({
    type: PASSWORD_CHANGE,
    password,
});

export const clearAuthError = authError => ({
    type: CLEAR_AUTH_ERROR,
    authError,
});


export const signOut = () => {
    setAuthToken(null);
};



// WEBPACK FOOTER //
// ./src/containers/common/auth/actions.js